(ns manatee.dashboard.handlers
  (:require [ajax.edn :refer [edn-response-format]]
            [kee-frame.core :as kf]
            [manatee.annotation.ids :as ids]
            [manatee.components.notifications.handlers :as notifications]
            [manatee.session.app-db :as session-db]
            [manatee.user.app-db :as user-db]
            [re-frame.core :as rf]))

(kf/reg-chain
 ::load-activity
 (fn load-activity
   [{:keys [db]} _]
   {:http-xhrio {:method :get
                 :uri (kf/path-for [:api/activity
                                    :user-id (user-db/get-user-id db)])
                 :response-format (edn-response-format)
                 :on-failure [::load-activity-failure]}})

 (fn load-activity-success
   [{:keys [db]} [activity]]
   {:db (session-db/set-activity db activity)}))

(rf/reg-event-fx
 ::load-activity-failure
 (fn load-activity-failure
   [{:keys [_db]} [_ _info]]
   {:dispatch [::notifications/add-alert ids/dashboard-alert-banner
               {:message "Unable to load dashboard. Please refresh the browser to try again or contact support if necessary."
                :type :error}
               :auto-dismiss? false]}))

(kf/reg-controller ::dashboard
                   {:params (fn [{:keys [handler]}]
                              (= handler ::dashboard))
                    :start (fn [{:keys [db]} active]
                             (when (and active (user-db/get-user-id db))
                               [::load-activity]))})
